import React from 'react';
import AvatarGroup from '@mui/material/AvatarGroup';
import {
  ChargeResponseProviderDTO,
} from 'dtos';
import ToolTip, {
  Props as ToolTipProps,
} from 'core/components/Tooltip';
import ProviderIcon from 'pages/Dashboard/pages/Billing/Charges/columns/ProviderIcon';

type Props = {
  tooltip: Omit<ToolTipProps, 'children'>;
  tipPlacement?: string;
  providers: ChargeResponseProviderDTO[];
  size: 'xs' | 'sm';
};

export default function ProvidersList({
  tooltip,
  providers = [],
  size = 'xs',
}: Props) {
  return (
    <ToolTip {...tooltip}>
      <AvatarGroup
        max={2}
        classes={{ avatar: '!h-5 !w-5 !text-xs' }}
      >
        {providers.map((provider) => (
          <ProviderIcon
            key={[provider?.billingProviderId, provider?.renderingProviderUserId].join('-')}
            size={size}
            {...(provider ?? {})}
          />
        ))}
      </AvatarGroup>
    </ToolTip>
  );
}
